const faqs = [
  {
    q: '黑料在线是什么类型的平台？',
    a: '黑料在线是一个专注于黑料视频的在线观看平台，提供海量娱乐圈、网红圈、综艺幕后等领域的黑料视频正片。本站支持黑料在线播放与黑料在线免费观看，每日更新最新黑料大瓜，是吃瓜群众获取最新爆料资讯的首选平台。',
  },
  {
    q: '黑料在线观看需要注册或付费吗？',
    a: '完全不需要！黑料在线视频全部免费观看，无需注册账号，无需支付任何费用。您可以直接访问本站，选择感兴趣的黑料内容进行在线观看黑料，没有任何门槛和限制。',
  },
  {
    q: '黑料在线的视频更新频率是怎样的？',
    a: '黑料在线保持每日更新，我们的内容团队全天候追踪全网最新黑料爆料动态，确保第一时间将最新黑料视频呈现在平台上。重大爆料事件发生时，我们会优先发布快讯和视频内容，让您不错过任何精彩大瓜。',
  },
  {
    q: '黑料在线播放的视频画质如何？是否支持手机观看？',
    a: '黑料在线所有视频均采用高清画质，支持在电脑、平板、手机等多种设备上流畅播放。黑料在线播放经过技术优化，在移动网络下也能稳定观看，无需担心卡顿或缓冲问题。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
            <i className="ri-question-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">关于黑料在线 · 您关心的都在这里</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="p-5 rounded-lg bg-background-50 border border-background-200/60">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q:</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}